
<template>
  <v-container fluid>
    <v-card class="d-flex pb-2 flex-column elevation-6 rounded-tl-xl">
      <v-card-title class="red darken-1 white--text justify-center">
        <v-col cols="12" class="pa-0 ma-0 d-flex justify-start">
          <v-btn icon color="blue-grey darken-1" :to="{name: 'SellerPage'}"><v-icon color="white">mdi-arrow-left</v-icon></v-btn>
        </v-col>
        <v-col cols="12" class="pa-0 ma-0 mb-2 d-flex flex-column justify-center align-center">
          <div >
            <v-icon class="mr-2 white--text" large>mdi-calendar</v-icon>
            Agenda de Pedidos
          </div>
        </v-col>
        <v-col cols="12">
          <v-row justify="center">
            <div class="d-flex flex-column justify-center align-center">
              <div class="text-h4 font-weight-bold text-center white--text text--darken-2 mb-3">
                {{ actual_month }}
              </div>
              <div class="d-flex">
                <v-btn width="120px" :disabled="loading.agenda" small @click="monthGoBack" class="d-flex align-center justify-center mx-2" color="white">
                  <v-icon small class="mr-2">mdi-chevron-left</v-icon>
                  <span>
                    Voltar 
                  </span>
                </v-btn>

                <v-btn width="120px" :disabled="loading.agenda" small @click="monthGoNext" class="d-flex align-center justify-center text-center mx-2" color="white">
                  <span>
                    Avançar
                  </span>
                  <v-icon small class="ml-2">mdi-chevron-right</v-icon>
                </v-btn>
              </div>
            </div>
          </v-row>
        </v-col>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="pb-0 mb-0">
            <DirectorSelectSeller @update="handleSelectedEmployee"></DirectorSelectSeller>
          </v-col>
          <v-col cols="12" md="6">
            <div class="d-flex flex-column ma-2">
              <span>Legenda:</span>
              <span class="red--text">
                <v-icon class="red--text">mdi-truck</v-icon>
                Frete interno
              </span>
              <span class="primary--text">
                <v-icon class="primary--text">mdi-truck</v-icon>
                Frete externo
              </span>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="d-flex align-center">
            <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Encontrar" clearable></v-text-field>
          </v-col>
        </v-row>
        <template v-if="loading.agenda">
          <v-card flat height="40vh" class="d-flex align-center"  >
            <v-card-text class="d-flex justify-center">
              <div class="d-flex flex-column align-center title">
                <span class="mb-2">Carregando...</span>
                <v-progress-circular  indeterminate color="blue-grey darken-1" size="50"></v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
        </template>
        <template v-if="!loading.agenda">
          <v-calendar ref="calendar" type="month" :start="start_date" :loading="loading.agenda"
            color="error" locale="pt-BR" :interval-count="0" :interval-height="0">
            <template v-slot:day="{ date }">
              <template v-for="(delivery, idx) in deliveries_by_date[date]">
                <v-sheet @click="goToOrder(delivery)" style="border-radius: 10px; cursor: pointer" color="grey lighten-3" class="black--text pa-1 ma-1 mb-3">
                  <div class="d-flex justify-center">
                    <span class="ml-1">
                      Pedido #{{ delivery?.order_id }}
                    </span>
                  </div>
                  <div class="d-flex">
                    <v-icon small :color="delivery.driver?.external ? 'primary' : 'red'">mdi-truck</v-icon>
                    <span class="ml-1">
                      {{ delivery?.driver?.name }}
                    </span>
                  </div>
                  <div class="d-flex">
                    <v-icon small :color="delivery.driver?.external ? 'primary' : 'red'">mdi-clipboard-account-outline</v-icon>
                    <span class="ml-1">
                      {{ delivery?.client_name }}
                    </span>
                  </div>
                  
                  <div class="d-flex justify-center">
                    <span class="text-caption">{{ delivery?.modality }}</span>
                  </div>
                </v-sheet>
              </template>
            </template>
          </v-calendar>
        </template>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Api from '@/api/index'
import cimentao_links from "@/mixins/cimentao_links";

export default {
  name: 'OrdersAgenda',
  mixins:[cimentao_links],
  components: {
    DirectorSelectSeller: () => import('@/components/seller/shared/DirectorSelectSeller.vue'),
  },
  data() {
    return {
      agenda: [],
      employee_id: null,
      search: null,
      month_off_set: 0,
      loading: {
        agenda: false,
      },
    }
  },
  computed:{
    start_date(){
      return this.$moment().subtract(this.month_off_set, 'M').startOf('month').format("YYYY-MM-DD")
    },
    deliveries_by_date() {
      const map = {}
      let filtered = this.agenda.map(element => element.attributes)
      // if (this.only_internal) {
      //   filtered = filtered.filter(obj => obj.internal == true)
      // } else if (this.only_external) {
      //   filtered = filtered.filter(obj => obj.internal == false)
      // }
      // } else {
        //   deliveries = filtered
      if (this.search) {
        filtered = filtered.filter(e => Object.values(e).find(v => {
          return String(v).toLowerCase().includes(this.search.toLowerCase())
        }) || e?.driver?.name.toLowerCase().includes(this.search.toLowerCase()))
      }
      filtered.forEach(e => (map[e.expected_delivery] = map[e.expected_delivery] || []).push(e))
      return map
    },
    actual_month() {
      const data = new Date();
      data.setMonth(data.getMonth() - this.month_off_set);
      const month_name = data.toLocaleDateString('pt-BR', { year: 'numeric', month: 'long' });
      return month_name.toUpperCase();
    },
  },
  methods: {
    getData(){
      this.getAgenda()
    },
    goToOrder(delivery){
      if(delivery.solution == 'retail'){
        this.goToRetailPage(delivery.order_id)
      }else{
        this.goToWholesalePage(delivery.order_id)
      }
    },
    monthGoBack() {
      this.month_off_set++;
    },
    monthGoNext() {
      this.month_off_set--;
    },
    getAgenda(){
      if(this.employee_id){
        this.loading.agenda = true 
        let params = {
          employee_id: this.employee_id,
          start_date: this.start_date
        }
        Api.Agenda.index(params).then((res)=>{
          this.agenda = [...res?.data?.data]
        }).finally(()=>{
          this.loading.agenda = false
        })
      }
    },
    handleSelectedEmployee(employee_id){
      this.employee_id = employee_id
    }
  },
  watch:{
    employee_id(){
      this.getData()
    },
    month_off_set(){
      this.getData()
    }
  },
  mounted () {
    this.getData()
  },
}
</script>
